//import { createModule, EffectParam, STATUS, ActionsDispatcher } from '../../modules/redux-acron/index'
import { createModule, EffectParam, STATUS, ActionsDispatcher } from 'redux-acron'
import { ActionCreatorsMapObject, AnyAction } from 'redux'
import { put, call } from 'redux-saga/effects'
import sagasRunner from '@utils/SagasRunner'
import api from '@services/api'
import useActions from '@hooks/useActions'

const DEFAULT_ERROR_MESSAGE = "Lo siento, no he podido procesar tu consulta, intenta nuevamente."

type IAResponseData = {
  content: string
  session?: string
  itemId?: string
  source?: string
}

export type IAAgentState = {
  waitingResponse: boolean
  data: IAResponseData | null
  waitingFeedback: boolean
  feedback: any | null
}

const IAAgentModule = createModule<IAAgentState>({
  name: 'iaAgent',
  state: {
    waitingResponse: false,
    data: null,
    waitingFeedback: false,
    feedback: null
  },
  handlers: {
    sendMessage: (state, { payload, status = STATUS.PENDING_STATUS }) => {

      if (status === STATUS.PENDING_STATUS) {
        return state.merge({ waitingResponse: true })
      }

      if (status === STATUS.SUCCESS_STATUS) {
        return state.merge({
          waitingResponse: false,
          data: payload

        })
      }

      if (status === STATUS.FAILURE_STATUS) {
        return state.merge({
          waitingResponse: false,
          data: {
            content: DEFAULT_ERROR_MESSAGE,
          }
        })
      }

      return state.merge({ waitingResponse: false })
    },
    sendFeedback: (state, { payload, status = STATUS.PENDING_STATUS }) => {

      if (status === STATUS.PENDING_STATUS) {
        return state.merge({ waitingFeedback: true })
      }

      if (status === STATUS.SUCCESS_STATUS) {
        return state.merge({
          waitingFeedback: false,
          feedback: payload
        })
      }

      if (status === STATUS.FAILURE_STATUS) {
        return state.merge({
          waitingFeedback: false,
          feedback: {
            content: DEFAULT_ERROR_MESSAGE,
          }
        })
      }

      return state.merge({ waitingResponse: false })
    },
  },
  effects: {
    sendMessage: {
      *callback(
        actions: ActionCreatorsMapObject,
        { payload }: EffectParam<{ query: string, tenant: string, session: string, userLogin: string }>
      ) {
        try {
          //console.log("saga triggered with:", payload)
          const response = yield call(
            api.iaAgent.sendMessage,
            payload.query,
            payload.tenant,
            payload.session ?? null,
            payload.userLogin
          )

          if (response.ok) {
            yield put(actions.sendMessage({ content: response.data.content, session: response.data.session, itemId: response.data.itemId, source: response.data.source }, STATUS.SUCCESS_STATUS))
          } else {
            yield put(actions.sendMessage({}, STATUS.FAILURE_STATUS))
          }
        } catch (err) {

          yield put(actions.sendMessage({}, STATUS.FAILURE_STATUS))
        }
      },
    },
    sendFeedback: {
      *callback(
        actions: ActionCreatorsMapObject,
        { payload }: EffectParam<{
          tenant: string,
          session: string,
          item: string,
          userLogin: string,
          rating: number,
          comment: string
        }>
      ) {
        try {
          //console.log("saga triggered with:", payload)
          const response = yield call(
            api.iaAgent.sendFeedback,
            payload.tenant,
            payload.session,
            payload.item,
            payload.userLogin,
            payload.rating,
            payload.comment
          )

          if (response.ok) {
            yield put(actions.sendFeedback({ content: response.data.content, session: response.data.session, source: response.data.source }, STATUS.SUCCESS_STATUS))
          } else {
            yield put(actions.sendFeedback({}, STATUS.FAILURE_STATUS))
          }
        } catch (err) {

          yield put(actions.sendFeedback({}, STATUS.FAILURE_STATUS))
        }
      },
    },
  },
})


export default IAAgentModule

export const reducer = (
  state: IAAgentState = IAAgentModule.initialState,
  action: AnyAction
): IAAgentState => {
  const handler = IAAgentModule?.actionHandlers?.[action.type]
  return handler ? handler(state, action) : state
}

export const rootSagas = sagasRunner(IAAgentModule.sagas, '/iaAgent')
export const { sendMessage } = IAAgentModule.actionCreators

export const actionDispacher = (): ActionsDispatcher => useActions(IAAgentModule.actionCreators, [])

